import { useState } from 'react';
import { AiOutlineEye } from '@react-icons/all-files/ai/AiOutlineEye';
import { AiOutlineEyeInvisible } from '@react-icons/all-files/ai/AiOutlineEyeInvisible';

import { Input, InputProps } from './Input';
import { trackEvent } from '../../analytics';

export function PasswordInput(props: InputProps) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Input
      {...props}
      type={showPassword ? 'text' : 'password'}
      rightIcon={showPassword ? AiOutlineEyeInvisible : AiOutlineEye}
      onRightIconClick={() => {
        trackEvent(!showPassword ? 'Password Revealed' : 'Password Hidden');
        setShowPassword(!showPassword);
      }}
    />
  );
}
